<template>
    <div class="image-card-container">
        <img v-if="src" :src="src" alt="" class="image-card">
        <div v-else class="placeholder-img-card"></div>
    </div>
</template>

<script>
    export default {
        props:{
            src:{ //图片路径
                type:String,
                required:true
            }
        },
        data() {
            return {}
        },
        methods:{
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/var.less";
    .image-card-container {
        width: 100%;
    }
    .image-card,
    .placeholder-img-card {
        width: 100%;
        height: 100px;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 11px;
    }
    .image-card {
        object-fit: cover;
    }
    .placeholder-img-card {
        background-color: placeholderImgColor;
    }
</style>